// @core/api/endpoints/form/update_form_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormPolicyResponse,
  UpdateFormPolicyRequest,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Update form policy
 * Updates an existing form policy.
 */
export async function UpdateFormPolicy(
  policy_id: string,
  data: UpdateFormPolicyRequest,
  options?: RequestOptions
): Promise<FormPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/form-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<FormPolicyResponse>(requestPath, data, requestOptions);
}
